import React from 'react'

interface Interface {
  desc: string
  name: string
  icon: string
  index: number
  focus: () => void
  active: number | null
  /** Template sources removed from, or kept unconfirmed in, this stage's groups. */
  flaggedCount?: number
}

export default ({ icon, index, focus, active, flaggedCount = 0 }: Interface) => (
  <div className="kt-notes__item h100">
    <div className="kt-notes__media cursor-pointer" onClick={focus}>
      {/* Relative on the circle, not on __media, which the theme positions
          absolutely. The badge then sits over the circle's top-right edge. */}
      <span
        className={active === index ? 'bg-brand kt-notes__icon' : 'kt-notes__icon'}
        style={{ position: 'relative' }}
      >
        <i className={active === index ? `${icon} fa-2x text-white` : `${icon} fa-2x`} />
        {flaggedCount > 0 && (
          <span
            className="badge badge-warning"
            style={{ position: 'absolute', top: -4, right: -6 }}
            title={`${flaggedCount} data source(s) from the template need checking`}
            data-testid="flagged-sources-badge"
          >
            {flaggedCount}
          </span>
        )}
      </span>
    </div>
  </div>
)
